export interface getResidentAgreement {
    /** 비대면동의서번호
     * @type {string}
     */
    nofcWtcnsNo: string
    /** 고객명
     * @type {string}
     */
    dbtoCsm: string
    /** 비대면 동의업무구분코드
     * @type {string}
     */
    nofcCosnBswrDcd: string
    /** 생년월일
     * @type {string}
     */
    birtYmd: string
    /** 자격구분명
     * @type {string}
     */
    qlfcDsncNm: string
    /** 지번주소
     * @type {string}
     */
    arnbAdr: string
    /** 도로명주소
     * @type {string}
     */
    rdnmAdr: string
    /** 고객동의일시
     * @type {string}
     */
    cstmTs: string
}

export const initialState: getResidentAgreement = {
    nofcWtcnsNo: '',
    dbtoCsm: '',
    nofcCosnBswrDcd: '',
    birtYmd: '',
    qlfcDsncNm: '',
    arnbAdr: '',
    rdnmAdr: '',
    cstmTs: '',
}
